<!--
 * @Description: 
 * @Author: HG
 * @Date: 2019-08-15 10:00:03
 * @LastEditors: HG
 * @LastEditTime: 2019-09-06 09:14:22
 -->
<template>
  <a-upload
    name="file"
    :listType="listType"
    class="avatar-uploader"
    :showUploadList="false"
    :action="actionUrl"
    :headers="header"
    @change="handleChange"
  >
    <img v-if="imageUrl" style="width: 100%;" :src="imageUrl" />
    <div v-else-if="listType == 'text'">
      <a-button type="primary"> <a-icon type="upload" /> {{ text }} </a-button>
    </div>
    <div v-else>
      <a-icon :type="loading ? 'loading' : 'plus'" />
      <div class="ant-upload-text">{{ text }}</div>
    </div>
  </a-upload>
</template>

<script>
import { cache } from "@/utils/common";
import urls from "@/api/url";
import uploadImg from "@/assets/images/upload.png";

export default {
  name: "upLoadImage",
  props: {
    value: {
      type: String,
      default: ""
    },
    listType: {
      type: String,
      default: "picture-card"
    },
    text: {
      type: String,
      default: "选择文件"
    },
    mode: {
      type: String,
      default: "filter"
    }
  },
  model: {
    prop: "value",
    event: "update"
  },
  watch: {
    value(val) {
      if (this.mode == "image") {
        this.imageUrl = val;
      } else if (val == "") {
        this.imageUrl = "";
      }
    }
  },
  data() {
    return {
      actionUrl: "",
      header: {},
      imageUrl: "",
      loading: false
    };
  },
  created() {
    if (this.value) {
      this.imageUrl = this.value;
    } else {
      this.imageUrl = "";
    }

    const user = cache.get("user");
    if (user) {
      const token = user.Token;
      if (token) {
        this.actionUrl = this.$config.serverUrl + urls["Common_upLoadFile"];
        this.header = {
          Authorization: token
        };
      }
    }
  },
  methods: {
    handleChange(res) {
      if (res && res.file && res.file.response) {
        // 如果上传成功
        if (res.file.response.Code == 0) {
          const url = res.file.response.Data;
          const fileUrl = this.$config.serverUrl + "/" + url;
          if (this.mode == "filter") {
            this.imageUrl = uploadImg;
          } else if (this.mode == "image") {
            this.imageUrl = fileUrl;
          } else if (this.mode == "file") {
            this.imageUrl = "";
          }
          this.$emit("update", fileUrl);
        }
      }
    }
  }
};
</script>
